/**
 * Cloud binding for the shared packet monitor.
 *
 * The monitor logic itself lives in `@trinetra/shared` — this file exists only
 * to inject the one cloud-specific piece (how browser inbound-rtp stats are
 * matched to a camera) and to keep existing import paths working.
 *
 * This was previously a ~380-line near-copy of local-node's implementation.
 * The two drifted, and a fix applied to one did not reach the other.
 */
import { configurePacketMonitor } from '@trinetra/shared';
import { captureStatsForCamera } from './cloud-stats-collector';

configurePacketMonitor({ captureStats: captureStatsForCamera });

export {
  MONITOR_DURATIONS,
  PacketMonitorSession,
  cancelPacketMonitor,
  clearPacketMonitor,
  getAllMonitors,
  getMonitor,
  handlePacketMonitorMessage,
  startPacketMonitor,
  subscribePacketMonitor,
  type FeRunningStats,
  type GetSignaling,
  type JitterLive,
  type MonitorState,
} from '@trinetra/shared';
